document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // SEARCH
  // ============================================
  const searchInput = document.querySelector('.search-input');
  const searchBtn = document.querySelector('.search-btn');
  
  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        const query = searchInput.value.trim();
        if (query) {
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        }
      }
    });
  }

  // ============================================
  // CATALOG FILTER (MODAL STYLE FOR LIST VIEW)
  // ============================================
  const filterSelect = document.getElementById('filter-type');
  const catalogList = document.getElementById('catalog-products');
  const catalogRows = document.querySelectorAll('.catalog-list-row'); // Updated class selector
  const catalogHeaders = document.querySelector('.catalog-list-header');
  const productCount = document.getElementById('product-count');
  const noResults = document.getElementById('catalog-no-results');
  const clearFilterBtn = document.getElementById('btn-clear-filter');
  const activeFilterLabel = document.getElementById('active-filter-label');
  
  // Modal elements
  const modalOverlay = document.getElementById('filter-modal-overlay');
  const modal = document.getElementById('filter-modal');
  const modalTitle = document.getElementById('filter-modal-title');
  const modalBody = document.getElementById('filter-modal-body');
  const modalClose = document.getElementById('filter-modal-close');
  const modalSearchInput = document.getElementById('filter-modal-search-input');

  // Get filter data
  const brandsInput = document.getElementById('data-brands');
  const linesInput = document.getElementById('data-lines');
  
  let brands = [];
  let lines = [];
  let currentFilterType = null;

  if (brandsInput && brandsInput.value) {
    brands = brandsInput.value.split('||').filter(b => b.trim() !== '').sort();
  }
  if (linesInput && linesInput.value) {
    lines = linesInput.value.split('||').filter(l => l.trim() !== '').sort();
  }

  // Count products
  function countByAttribute(attr, value) {
    return Array.from(catalogRows).filter(item => {
      return (item.getAttribute('data-' + attr) || '').toLowerCase() === value.toLowerCase();
    }).length;
  }

  // Open modal
  function openModal(type) {
    currentFilterType = type;
    let items = [];
    let title = '';

    if (type === 'marca') {
      items = brands;
      title = 'Seleccionar Marca';
    } else if (type === 'linea') {
      items = lines;
      title = 'Seleccionar Línea de Producto';
    }

    if (modalTitle) modalTitle.textContent = title;
    if (modalSearchInput) modalSearchInput.value = '';

    // Build modal body
    let html = `<button class="filter-modal-item filter-modal-item-all" data-value="__ALL__">VER TODO</button>`;
    
    items.forEach(item => {
      const count = countByAttribute(type === 'marca' ? 'marca' : 'linea', item);
      html += `
        <button class="filter-modal-item" data-value="${item}">
          <span>${capitalize(item)}</span>
          <span class="item-count">${count}</span>
        </button>
      `;
    });

    if (modalBody) modalBody.innerHTML = html;

    // Attach click events
    modalBody.querySelectorAll('.filter-modal-item').forEach(btn => {
      btn.addEventListener('click', function() {
        const value = this.getAttribute('data-value');
        applyFilter(value);
        closeModal();
      });
    });

    // Show modal
    if (modalOverlay) modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Focus search
    setTimeout(() => {
      if (modalSearchInput) modalSearchInput.focus();
    }, 200);
  }

  function closeModal() {
    if (modalOverlay) modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
    if (filterSelect) filterSelect.value = '-';
  }

  function capitalize(str) {
    return str.replace(/\b\w/g, l => l.toUpperCase());
  }

  // Apply filter
  function applyFilter(value) {
    if (!catalogRows.length) return;

    let visibleCount = 0;

    if (value === '__ALL__') {
      catalogRows.forEach(item => {
        item.style.display = 'grid'; // Changed to grid for row layout
        visibleCount++;
      });
      if (activeFilterLabel) {
        activeFilterLabel.style.display = 'none';
        activeFilterLabel.textContent = '';
      }
    } else {
      const attr = currentFilterType === 'marca' ? 'marca' : 'linea';
      catalogRows.forEach(item => {
        const itemValue = (item.getAttribute('data-' + attr) || '').toLowerCase();
        
        let isMatch = false;
        if (attr === 'linea') {
           // For collections/lines it can be multiple delimited by ||
           isMatch = itemValue.includes(value.toLowerCase() + '||') || itemValue === value.toLowerCase() || itemValue.includes('||' + value.toLowerCase() + '||');
        } else {
           isMatch = itemValue === value.toLowerCase();
        }

        if (isMatch) {
          item.style.display = 'grid'; // Changed to grid for row layout
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      });
      // Active filter badge
      if (activeFilterLabel) {
        activeFilterLabel.style.display = 'inline-flex';
        activeFilterLabel.textContent = capitalize(value);
      }
    }

    if (productCount) productCount.textContent = visibleCount;

    // No results view
    if (visibleCount === 0) {
      if (catalogList) catalogList.style.display = 'none';
      if (noResults) noResults.style.display = 'flex';
    } else {
      if (catalogList) catalogList.style.display = 'flex';
      if (catalogHeaders) catalogHeaders.style.display = 'grid';
      if (noResults) noResults.style.display = 'none';
    }
  }

  // Clear filter
  function clearFilter() {
    catalogRows.forEach(item => { item.style.display = 'grid'; });
    if (productCount) productCount.textContent = catalogRows.length;
    if (catalogList) catalogList.style.display = 'flex';
    if (catalogHeaders) catalogHeaders.style.display = 'grid';
    if (noResults) noResults.style.display = 'none';
    if (activeFilterLabel) {
      activeFilterLabel.style.display = 'none';
      activeFilterLabel.textContent = '';
    }
    if (filterSelect) filterSelect.value = '-';
  }

  // Dropdown trigger
  if (filterSelect) {
    filterSelect.addEventListener('change', function() {
      const value = this.value;
      if (value === 'marca' || value === 'linea') {
        openModal(value);
      }
    });
  }

  // Modals close events
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalOverlay) {
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) closeModal();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay && modalOverlay.classList.contains('active')) {
      closeModal();
    }
  });

  if (clearFilterBtn) clearFilterBtn.addEventListener('click', clearFilter);
  if (activeFilterLabel) activeFilterLabel.addEventListener('click', clearFilter);

  // Modal search
  if (modalSearchInput) {
    modalSearchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();
      const items = modalBody.querySelectorAll('.filter-modal-item:not(.filter-modal-item-all)');
      items.forEach(item => {
        const text = item.textContent.toLowerCase();
        item.style.display = text.includes(query) ? 'flex' : 'none';
      });
    });
  }

  // ============================================
  // QUICK ADD TO CART (Shopify Ajax API)
  // ============================================
  const quickAddBtns = document.querySelectorAll('.btn-quick-add');

  function addToCart(variantId, button) {
    if (!variantId) return;
    
    const originalText = button.innerHTML;
    button.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style="animation: spin 0.6s linear infinite"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="2" stroke-dasharray="30" stroke-dashoffset="10"/></svg>';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
      button.innerHTML = '✓ Agregado';
      button.style.background = '#00c853';
      
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = cart.item_count;
        });

      setTimeout(() => {
        button.innerHTML = originalText;
        button.style.background = '';
        button.disabled = false;
      }, 1500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.innerHTML = originalText;
      button.disabled = false;
    });
  }

  quickAddBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = this.getAttribute('data-variant-id');
      addToCart(variantId, this);
    });
  });

  // Spin animation
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { 100% { transform: rotate(360deg); } }';
  document.head.appendChild(style);

});
